import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    initials: 'SL',
    name: 'Soledad L.',
    location: 'Buenos Aires 🇦🇷',
    quote: 'Compré un sábado. El domingo a la tarde tenía todo el mes de clases organizado. Nunca más improviso.'
  }, {
    initials: 'MR',
    name: 'Marcela R.',
    location: 'Córdoba 🇦🇷',
    quote: 'Tres alumnos de nivel inicial que estaban estancados mejoraron su producción oral en el primer mes con el Tomo 3.'
  }, {
    initials: 'GP',
    name: 'Gastón P.',
    location: 'Rosario 🇦🇷',
    quote: 'Antes tardaba 2 horas armando una clase desde cero. Ahora son 10 minutos exactos.'
  }, {
    initials: 'LV',
    name: 'Laura V.',
    location: 'Mendoza 🇦🇷',
    quote: 'El Nivelómetro me salvó con un alumno nuevo que decía que era B2 y era A2. En 15 minutos supe exactamente dónde ubicarlo sin incómodos.'
  }, {
    initials: 'FM',
    name: 'Fabián M.',
    location: 'Santa Fe 🇦🇷',
    quote: 'El Método Viajero Express me generó $28.000 el primer mes. Un alumno que viajaba a Roma me compró el curso completo antes de que terminara de explicarle.'
  }, {
    initials: 'PR',
    name: 'Patricia R.',
    location: 'Tucumán 🇦🇷',
    quote: 'La Corrección Automática Pro cambió mi relación con la enseñanza. Termino las semanas con energía, no corrigiendo carpetas a la madrugada.'
  }];
  return <section className="py-20 bg-[#FAF7F2]" data-id="element-296">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-297">
        <div className="text-center mb-16" data-id="element-298">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-299">
            Lo que dicen los profesores
          </h2>
          <div className="flex items-center justify-center text-yellow-400 text-xl" data-id="element-300">
            <span className="text-[#1A1A1A] font-bold mr-2" data-id="element-301">4.9/5</span>
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-302" />)}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-303">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-304">
              <div className="flex items-center mb-4" data-id="element-305">
                <div className="w-12 h-12 bg-gray-100 text-gray-600 rounded-full flex items-center justify-center font-bold text-lg mr-4" data-id="element-306">
                  {t.initials}
                </div>
                <div data-id="element-307">
                  <p className="font-bold text-[#1A1A1A]" data-id="element-308">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-309">{t.location}</p>
                </div>
              </div>
              <div className="flex text-yellow-400 mb-4" data-id="element-310">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-5 h-5 fill-current" data-id="element-311" />)}
              </div>
              <p className="text-gray-700 italic font-serif text-lg leading-relaxed" data-id="element-312">
                "{t.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}